export const sharedFeatureKey = 'shared';
